export const sharedFeatureKey = 'shared';
